import { Box, Button, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';
import type { ComponentType } from 'react';
import type { Icon } from '@tabler/icons-react';

export interface EmptyStateProps {
  title?: string;
  description?: string;
  /** Tabler icon component. Defaults to IconInbox. */
  icon?: ComponentType<React.ComponentProps<Icon>>;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({
  title = 'No data',
  description,
  icon: Icon = IconInbox,
  action,
}: EmptyStateProps) {
  return (
    <Box
      py="xl"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 180,
      }}
    >
      <Stack align="center" gap="sm">
        <ThemeIcon
          size={48}
          variant="light"
          color="mist"
          radius="xl"
        >
          <Icon size={24} stroke={1.5} />
        </ThemeIcon>

        <Stack align="center" gap={4}>
          <Text fw={600} c="slate.7" size="sm">
            {title}
          </Text>
          {description && (
            <Text size="sm" c="dimmed" ta="center" maw={320} lh={1.5}>
              {description}
            </Text>
          )}
        </Stack>

        {action && (
          <Button
            variant="light"
            color="aquifer"
            size="sm"
            mt={4}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
